import * as React from "react";

/*
 * A sub heading. You know, the text that might show up under a heading.
 */
export class Subheading extends React.Component<{ children?: React.ReactNode }, {}> {
  render(): JSX.Element {
    return (
      <div
        style={{
          fontSize: "28px",
          color: "#ababab",
          fontWeight: 300,
          marginTop: "-10px",
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
